import { useInformationBannerApi } from '@api/information-banner.hook'

export default defineNuxtRouteMiddleware(() => {
  void useInformationBannerApi()
})
